import { render, staticRenderFns } from "./record_class.vue?vue&type=template&id=9104029e&scoped=true"
import script from "./record_class.vue?vue&type=script&lang=js"
export * from "./record_class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9104029e",
  null
  
)

export default component.exports